import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startDateMissingErrorTitle: {
		id: 'business-timeline.controllers.update-item.start-date-missing-error-title',
		defaultMessage: "We couldn't save the item",
		description: 'Error message informing the user that updating the item failed',
	},
	startDateMissingErrorMessage: {
		id: 'business-timeline.controllers.update-item.start-date-missing-error-message',
		defaultMessage: "Field 'Start date' cannot be set. It is not on the appropriate screen.",
		description: 'Warning message when user does not set start date field in a project',
	},
	scheduleItemErrorTitle: {
		id: 'business-timeline.controllers.update-item.schedule-item-error-title',
		defaultMessage: "Something's gone wrong",
		description: 'Error message informing the user that schedule an item has failed',
	},
	scheduleItemErrorDescription: {
		id: 'business-timeline.controllers.update-item.schedule-item-error-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Flag description. Informs a user that schedule an item has failed.',
	},
	scheduleItemNotFound: {
		id: 'business-timeline.controllers.update-item.schedule-item-not-found',
		defaultMessage: 'Issue not found',
		description: 'Error message informing the user that scheduled item is not found',
	},
	scheduleItemRemoved: {
		id: 'business-timeline.controllers.update-item.schedule-item-removed',
		defaultMessage: 'Looks like this issue has been removed.',
		description: 'Error message informing the user that scheduled item is removed',
	},
	scheduleItemNotFoundIssueTermRefresh: {
		id: 'business-timeline.controllers.update-item.schedule-item-not-found-issue-term-refresh',
		defaultMessage: 'Work item not found',
		description: 'Error message informing the user that scheduled item is not found',
	},
	scheduleItemRemovedIssueTermRefresh: {
		id: 'business-timeline.controllers.update-item.schedule-item-removed-issue-term-refresh',
		defaultMessage: 'Looks like this work item has been removed.',
		description: 'Error message informing the user that scheduled item is removed',
	},
});
